<template>
  <div class="user-form">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>設定</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="会社名:" label-cols-md="3" label-align-md="right">
            <FormValidatorText name="会社名" :form="$v.form.company" />
          </b-form-group>
          <b-form-group label="名前:" label-cols-md="3" label-align-md="right">
            <FormValidatorText name="名前" :form="$v.form.name" />
          </b-form-group>
          <b-form-group label="メールアドレス:" label-cols-md="3" label-align-md="right">
            <FormValidatorEmail name="メールアドレス" :form="$v.form.email" />
          </b-form-group>
          <b-form-group label="備考:" label-cols-md="3" label-align-md="right">
            <FormValidatorTextarea name="備考" :form="$v.form.comment" />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">更新</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'UserForm',

  computed: {
    ...mapState({
      form: state => state.users.form,
    }),
  },

  validations: {
    form: {
      company: {
        maxLength: maxLength(255),
      },
      name: {
        required,
        maxLength: maxLength(255),
      },
      email: {
        required,
        email: email,
        maxLength: maxLength(255),
      },
      comment: {
        maxLength: maxLength(65536),
      },
    },
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store.dispatch('users/updateItem', this.form);
      } else {
        this.$store.dispatch('users/addItem', this.form);
      }
    },

    onReset(evt) {
      this.$v.form.$reset();
      if (this.form.id) {
        this.$store.dispatch('users/loadForm', this.form.id);
      } else {
        this.$store.dispatch('users/clearForm');
      }
    },
  },
};
</script>

<style scoped>
</style>
